import React, { useState, useEffect } from "react";
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
export default function AddBarberServiceModal({
  isOpen,
  service,
  onSave,
  onClose,
}) {
  const [name, setName] = useState("");
  const [time, setTime] = useState(1);

  // Fill fields when service is provided
  useEffect(() => {
    if (service) {
      setName(service.name || "");
      setTime(service.time || 0);
    } else {
      clearForm();
    }
  }, [service, isOpen]);

  // Clears form fields
  const clearForm = () => {
    setName("");
    setTime(0);
  };

  // Handle save
  const handleSave = () => {
    // send back to parent
  };

  return (
    <div className={`modal  ${isOpen ? "show" : ""}`} tabindex="-1">
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{name}</h5>
          </div>
          <div className="modal-body">
            <div className="row client-form">
              <div className="col-12 form-control-container">
                <label htmlFor="name" className="form-label">
                  Please enter the duration required for this service .(in
                  minutes)
                </label>
                <input
                  type="number"
                  className="form-control form-input"
                  value={time}
                  min="1"
                  onChange={(e) => setTime(Number(e.target.value))}
                />
              </div>

              <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
                <button
                  type="submit"
                  className="btn btn-secondary me-2"
                  onClick={() => onClose()}
                >
                  Cancel
                </button>{" "}
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={(e) => onSave(time)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
